import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "./slices/user";
import productReducer from "./slices/products";
import cartReducer from "./slices/cart-slice";
import wishlistReducer from "./slices/wishlist-slice";
import annnoucementReducer from "./slices/annoucement";
import globalReducer from "./slices/global";
import walletReducer from "./slices/wallet";
import salesReducer from "./slices/sales";

const persistConfig = {
  key: "flone",
  version: 1.1,
  storage,
};

export const rootReducer = combineReducers({
  user: userReducer,
  product: productReducer,
  cart: cartReducer,
  wishlist: wishlistReducer,
  annoucement: annnoucementReducer,
  global: globalReducer,
  wallet: walletReducer,
  sales: salesReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type RootState = ReturnType<typeof rootReducer>;

export const persistor = persistStore(store);
